import { getFormValues, } from 'redux-form' // ES6;
import { ANULACION_FORM_NAME, ANULACION_FORM_NAME_V2, DEVOLUCIONES_FORM_NAME, FORM_NAME_ANULATION_FORM, REGISTRO_AND_APORTES_FORM_NAME, REPORTS_FORM_NAME } from './constants';

export const getFormValuesDevolucion = (state) => getFormValues(DEVOLUCIONES_FORM_NAME)(state);
export const getFormValuesRyaForm = (state) => getFormValues(REGISTRO_AND_APORTES_FORM_NAME)(state);
export const getFormValuesAnulacion = (state) => getFormValues(ANULACION_FORM_NAME)(state);
export const getFormValuesAnulacionFormMotivo = (state) => getFormValues(ANULACION_FORM_NAME_V2)(state);
export const getFormValuesFilter = (state) => getFormValues(REPORTS_FORM_NAME)(state);
export const getFormValuesAnulationForm = (state) => getFormValues(FORM_NAME_ANULATION_FORM)(state);

export const getDataRegCompany = (state) => state.localReducer.dataRegCompany;
export const getDataReportsCompany = (state) => state.localReducer.dataReportsCompany;
export const getOpenFormBandeja = (state) => state.localReducer.openFormBandeja;
export const getIdFormulario = (state) => state.localReducer.idFormulario;
export const getOpenSeeAnexos = (state) => state.localReducer.openSeeAnexos;
export const getOcultaDevoluciones = (state) => state.localReducer.ocultaDevoluciones;
export const getNameButtonDev = (state) => state.localReducer.nameButtonDev;
export const getMessageConfirmation = (state) => state.localReducer.messageConfirmation;
export const getMessageAlert = (state) => state.localReducer.messageAlert;
export const getMessageAnulationRya = (state) => state.localReducer.messageAnulationRya;
export const getMessageHistory = (state) => state.localReducer.messageHistory;
export const getConsultaPaginada = (state) => state.localReducer.consultaPaginada;
export const getConsultaPaginadaReports = (state) => state.localReducer.consultaPaginadaReports;
export const getSessionValidated = (state) => state.localReducer.sessionValidated;
export const getUserInfo = (state) => state.localReducer.userInfo;

export const getHistoryBandeja = (state) => state.localReducer.historyBandeja;
export const getUserType = (state) => state.localReducer.userType;
export const getSuc_id = (state) => state.localReducer.suc_id;
export const getIdUsuaAsesor = (state) => state.localReducer.idUsuaAsesor;
export const getMessageConfirmationRya = (state) => state.localReducer.messageConfirmationRya;
export const getDynamicOptions = (state) => state.localReducer.dynamicOptions;
export const getOpenModalCharged = (state) => state.localReducer.openModalCharged;
export const getOpenComponentInformes = (state) => state.localReducer.openInformes;
export const getSnackBar = (state) => state.localReducer.showSnackBar;
export const getDynamicDisable = (state) => state.localReducer.dynamicDisable;
export const getDataModalDatos = (state) => state.localReducer.dataModalDatos;
export const getConsultaReports = (state) => state.localReducer.consultaReports;
export const getErrorTryCatch = (state) => state.localReducer.errorTryCatch;
export const getOpenMondalTryCatch = (state) => state.localReducer.openMondalTryCatch;
export const getTotalConsultaReports = (state) => state.localReducer.totalConsultaReports;
export const getMsgParametrizados = (state) => state.localReducer.msgParametrizados;
export const getDataAnulationForm = (state) => state.localReducer.dataAnulationForm;
export const getOpenAnulationForm = (state) => state.localReducer.openAnulationForm;